import React from 'react'
import PropTypes from 'prop-types'
import { STATUS_FINISH, STATUS_TYPES, StepNumber, StepsSeparator } from './StepsIndicator.styles'
import Icon from '../Icon'
import Flex from '../Flex'
import Box from '../Box'

export const StepProgress = ({ currentStep, status, nextStatus, totalSteps }) =>
    <Flex width={['100%', '100%', '35px']} justifyContent={['center', 'center', 'flex-start']} >
        <Box width='calc(100% - 35px)' display={['block', 'block', 'none']}>
            { (currentStep > 1) && <StepsSeparator status={status} /> }
        </Box>
        <Box width={['55px', '45px', '35px']} textAlign={['center', 'center', 'left']} p={['0 5px', '0 5px', '0']}>
            <StepNumber status={status}>
                    {status === STATUS_FINISH
                        ? <Icon type='ok' size='xxxSmall' color='white'/>
                        : currentStep
                    }
            </StepNumber>
        </Box>
        <Box width='calc(100% - 35px)' display={['block', 'block', 'none']}>
            { (currentStep < totalSteps) && <StepsSeparator status={nextStatus} />}
        </Box>
    </Flex>

StepProgress.propTypes = {
    currentStep: PropTypes.number,
    totalSteps: PropTypes.number,
    status: PropTypes.oneOf(STATUS_TYPES),
    nextStatus: PropTypes.oneOf(STATUS_TYPES),
}

export default StepProgress
